<va-filter-container
  [filters]="filters$ | async"
  (searchTermChanged)="onSearchTermChanged($event)"
  (fieldValueChanged)="onFieldValueChanged($event)"
  [theme]="'plain'"
  [filterIsOpen]="showLMIFilter$ | async"
  [useCustomCase]="useCustomCase"
  [filtersDisabled]="filtersDisabled"
>
  <ng-container content>
    @if ((packagesMap$$ | async).size > 0) {
      <store-component
        [items]="filteredItems$ | async"
        [currencyCode]="currencyCode"
        [searchable]="false"
        (itemClicked)="storeItemClicked($event)"
        [showAllPrices]="showAllPrices"
      ></store-component>
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </ng-container>
</va-filter-container>
